import { CheckPermissionLayout } from 'layouts';
import { RouteObject } from 'react-router-dom';
import { PERMISSION } from 'utils';
import { ROUTE } from './constants';
import { lazy } from 'react';

export const accessAIAgentCenterRoutes: RouteObject[] = [
  {
    element: <CheckPermissionLayout permission={[PERMISSION.MONITOR_AI_AGENT]} />,
    children: [
      {
        path: ROUTE.AI_AGENT_MANAGEMENT,
        children: [
          {
            index: true,
            Component: lazy(() => import('pages/AIAgentCenterPage'))
          }
        ]
      }
    ]
  }
];
